var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-plus-outlined",
    d: "M22113,13389.373a12,12,0,1,1,11.992,11.994A12,12,0,0,1,22113,13389.373Zm1.6,0a10.4,10.4,0,1,0,10.391-10.4A10.4,10.4,0,0,0,22114.6,13389.373Zm9.594,4.8v-4h-4a.8.8,0,0,1,0-1.609h4v-4a.8.8,0,1,1,1.6,0v4h4a.8.8,0,0,1,0,1.609h-4v4a.8.8,0,0,1-1.6,0Z",
    transform: "translate(-22113 -13377.367)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusOutlined);
export default __webpack_public_path__ + "static/media/icon-plus-outlined.73d07780ad16c2ac43a00671cce614ab.svg";
export { ForwardRef as ReactComponent };